// src/components/AddProductFromInboundModal.tsx
// Открывается поочерёдно для каждой новой позиции в InboundModal у которой нет productId.
// Сохраняет товар в IndexedDB, затем вызывает onCreated(item) с полным объектом.

import React, { useCallback } from 'react';
import { Modal } from 'antd';
import { STORE_NAMES } from '../utils/db';
import type { StoreName } from '../utils/db';
import { apiCreateProduct } from '../services/productAPI';

import SparkPlugForm    from './forms/SparkPlugForm';
import IgnitionCoilForm from './forms/IgnitionCoilForm';
import SensorForm       from './forms/SensorForm';
import SteeringClockForm from './forms/SteeringClockForm';
import WiresForm        from './forms/WiresForm';

const CATEGORY_LABELS: Record<string, string> = {
  [STORE_NAMES.sparkPlugs]:     'Свечи зажигания',
  [STORE_NAMES.coils]:          'Катушки зажигания',
  [STORE_NAMES.sensors]:        'Датчики',
  [STORE_NAMES.steeringClocks]: 'Рулевые шлейфы',
  [STORE_NAMES.wires]:          'Наконечники и провода',
};

type Props = {
  open: boolean;
  category: string;
  onCreated: (item: any) => void;
  onClose: () => void;
  queuePosition: number;
  queueTotal: number;
};

const AddProductFromInboundModal: React.FC<Props> = ({
  open, category, onCreated, onClose, queuePosition, queueTotal,
}) => {
  const handleAdd = useCallback(async (item: any) => {
    const newId = await apiCreateProduct(item, category as StoreName);
    onCreated({ ...item, id: newId });
  }, [category, onCreated]);

  const formProps = { onAdd: handleAdd, initialValues: null };

  const renderForm = () => {
    switch (category) {
      case STORE_NAMES.sparkPlugs:     return <SparkPlugForm     {...formProps} />;
      case STORE_NAMES.coils:          return <IgnitionCoilForm  {...formProps} />;
      case STORE_NAMES.sensors:        return <SensorForm        {...formProps} />;
      case STORE_NAMES.steeringClocks: return <SteeringClockForm {...formProps} />;
      case STORE_NAMES.wires:          return <WiresForm         {...formProps} />;
      default:                          return null;
    }
  };

  const queueSuffix = queueTotal > 1 ? ` (${queuePosition} из ${queueTotal})` : '';
  const label = CATEGORY_LABELS[category] ?? category;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={`Новый товар — ${label}${queueSuffix}`}
      footer={null}
      width={700}
      destroyOnHidden
    >
      {open && renderForm()}
    </Modal>
  );
};

export default AddProductFromInboundModal;
